import { createSelector } from 'reselect';

import { getConfig } from './config';

export default createSelector([getConfig], config => {
  return config.printerless;
});
